import { Filter } from "mushroomjs";

export function getSystemType() {
  return localStorage.getItem("system_type") || "probe";
}

export function getCurrentPid() {
  const type = getSystemType();
  if (type === "summary") {
    return localStorage.getItem("pid_summary") || "";
  }
  return localStorage.getItem("pid_probe") || "";
}

export function getSystemTypes() {
  return [getSystemType(), null];
}

export function getSystemTypeFilter(baseFilter = Filter) {
  const types = getSystemTypes();
  if (types.length === 1) {
    return baseFilter.eq("type", types[0]);
  } else {
    return baseFilter.and(
      Filter.or(
        types.map((type) =>
          type ? Filter.eq("type", type) : Filter.isNull("type"),
        ),
      ),
    );
  }
}

export function redirectToPrimaryLogin(currentPath) {
  const urlPrimary = localStorage.getItem("urlPrimary");
  if (!urlPrimary) {
    window.location.href = "/error";
    return;
  }

  localStorage.removeItem("userInfo");

  const systemType = getSystemType();
  const pidProbe = localStorage.getItem("pid_probe") || "";
  const pidSummary = localStorage.getItem("pid_summary") || "";
  const lang = localStorage.getItem("language") || "vi";

  const menu = currentPath || "/home";

  const redirectUrl = `${window.location.origin}/entry.html?system_type=${systemType}&pid_probe=${pidProbe}&pid_summary=${pidSummary}&lang=${lang}&menu=${encodeURIComponent(menu)}`;
  window.location.href = `${urlPrimary}login?redirect_url=${encodeURIComponent(redirectUrl)}`;
}
